import React from 'react';
import Slider from 'react-slick';
import {Link} from 'react-router-dom';
import './Clients.css';
// import ambank from '../../assets/img/clients/ambank.png';
// import arabia_insurance from '../../assets/img/clients/arabia_insurance.png';
import atak from '../../assets/img/clients/atak.png';
import auchan from '../../assets/img/clients/auchan.png';
// import bandq from '../../assets/img/clients/bandq.png';
// import bankaudi from '../../assets/img/clients/bankaudi.png';
import bdl from '../../assets/img/clients/bdl.png';
// import bemo from '../../assets/img/clients/bemo.png';
import bhv from '../../assets/img/clients/bhv.png';
import bob from '../../assets/img/clients/bob.png';
import bobfinance from '../../assets/img/clients/bobfinance.png';
import cvs from '../../assets/img/clients/cvs.png';
import qib from '../../assets/img/clients/qib.png';
import kafalat from '../../assets/img/clients/kafalat.png';
import fnac from '../../assets/img/clients/fnac.png';
import carrefour from '../../assets/img/clients/carrefour.png';
import canadiantyre from '../../assets/img/clients/canadiantyre.png';
import lafayette from '../../assets/img/clients/lafayette.png';
import target from '../../assets/img/clients/target.png';
import fransa from '../../assets/img/clients/fransa.png';
import blf from '../../assets/img/clients/blf.png';
import csc from '../../assets/img/clients/csc.png';
import bandq from '../../assets/img/clients/bandq.png';
import fin from '../../assets/img/clients/fin.png';
import king from '../../assets/img/clients/king.png';
import louisdelhaize from '../../assets/img/clients/louisdelhaize.png';
import mono from '../../assets/img/clients/mono.png';
import nasco from '../../assets/img/clients/nasco.png';
import oken from '../../assets/img/clients/oken.png';
import oracle from '../../assets/img/clients/oracle.png';
import provera from '../../assets/img/clients/provera.png';
import refinitiv from '../../assets/img/clients/refinitiv.png';
import thomsonreuters from '../../assets/img/clients/thomsonreuters.png';
import simply from '../../assets/img/clients/simply.png';
import valeo from '../../assets/img/clients/valeo.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Clients = () => {
    const client_list = [
        
        {
            image: carrefour,
            link: 'https://www.carrefour.com'
        },
        // {
        //     image: qib,
        //     link: 'https://www.qib.com.qa'
        // },
        // {
        //     image: bob,
        //     link: 'https://insurance.valoores.com/'
        // },
        // {
        //     image: kafalat,
        //     link: 'https://kafalat.com.lb/'
        // },
        {
            image: fnac,
            link: 'https://fnac.com/'
        },
        {
            image: cvs,
            link: 'https://www.cvs.com'
        },
        // {
        //     image: bdl,
        //     link: 'https://insurance.valoores.com/'
        // },
        // {
        //     image: bobfinance,
        //     link: 'https://insurance.valoores.com/'
        // },
        {
            image: canadiantyre,
            link: 'https://www.canadiantire.ca/en.html'
        },
        // {
        //     image: fransa,
        //     link: 'https://www.fransabank.com/'
        // },
        // {
        //     image: blf,
        //     link: 'https://www.eblf.com/'
        // },
        // {
        //     image: abl,
        //     link: 'https://banking.valoores.com/'
        // },
        // {
        //     image: ambank,
        //     link: 'https://insurance.valoores.com/'
        // },
        // {
        //     image: arabia_insurance,
        //     link: 'https://insurance.valoores.com/'
        // },
        // {
        //     image: atak,
        //     link: 'https://insurance.valoores.com/'
        // },
        {
            image: auchan,
            link: 'https://banking.valoores.com/'
        },
        {
            image: bandq,
            link: 'https://insurance.valoores.com/'
        },
        // {
        //     image: bankaudi,
        //     link: 'https://banking.valoores.com/'
        // },
        // {
        //     image: bemo,
        //     link: 'https://insurance.valoores.com/'
        // },
        {
            image: bhv,
            link: 'https://insurance.valoores.com/'
        },
        {
            image: csc,
            link: 'https://insurance.valoores.com/'
        },
        {
            image: target,
            link: 'https://www.carrefour.com'
        },
        {
            image: lafayette,
            link: 'https://fnac.com/'
        },
        {
            image: bandq,
            link: 'https://fnac.com/'
        },
        {
            image: fin,
            link: 'https://fnac.com/'
        },
        {
            image: king,
            link: 'https://fnac.com/'
        },
        {
            image: louisdelhaize,
            link: 'https://fnac.com/'
        },
        {
            image: mono,
            link: 'https://fnac.com/'
        },
        {
            image: nasco,
            link: 'https://fnac.com/'
        },
        // {
        //     image: oken,
        //     link: 'https://fnac.com/'
        // },
        {
            image: oracle,
            link: 'https://fnac.com/'
        },
        {
            image: provera,
            link: 'https://fnac.com/'
        },
        {
            image: refinitiv,
            link: 'https://fnac.com/'
        },
        {
            image: simply,
            link: 'https://fnac.com/'
        },
        {
            image: thomsonreuters,
            link: 'https://fnac.com/'
        },
        {
            image: valeo,
            link: 'https://fnac.com/'
        },
    ]

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style, display: "block", transform: 'scale(2)', color: '#001d6e!important', zIndex: '5' }}
            onClick={onClick}
          />
        );
      }
      
      function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style, display: "block", transform: 'scale(2)', color: '#001d6e!important', zIndex: '5' }}
            onClick={onClick}
          />
        );
      }

    const settings = {
        easing: 'linear',
        // fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 5,
        slidesToScroll: 2,
        dots: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
    };

  return (
    <>
        <div className="clients__container" id='partners_scroll'>
            <div className="container">
                <div className="row">
                    <div className="services__title">
                        <h2>Sharing with you <span>our list of partners</span></h2>
                    </div>
                    </div>
                    <Slider {...settings}>
                        {client_list.map((client, index) => (
                            <div className="d-flex justify-content-center" key={index}>
                                <img src={client.image} alt="" className='w-75' style={{filter: 'grayscale(1)'}} loading="lazy"/>
                                {/* <Link className='d-flex justify-content-center' target="_blank"  to={client.link}>
                                    <img src={client.image} alt="" className='w-75' style={{filter: 'grayscale(1)'}}/>
                                </Link> */}
                            </div>
                        ))}
                    </Slider>
            </div>
        </div>
    </>
  )
}

export default Clients